(function() {
  'use strict';

  if (window.LoomCoffeeBrewTimer) {
    window.LoomCoffeeBrewTimer.init(document);
    return;
  }

  var SELECTOR = '[data-coffee-brew-timer]';
  var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  var CIRCUMFERENCE = 2 * Math.PI * 99;
  var RING_SEGMENT_GAP = 3;
  var BASE_TIMINGS = {
    drip: { bloom: 40, total: 180 },
    french_press: { steep: 240, total: 270 },
    espresso: { total: 28 }
  };
  var instances = new Map();

  function roundedNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.round(number) : null;
  }

  function numericNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function formatNumber(value) {
    return String(Number(value.toFixed(1)));
  }

  function replaceTokens(template, values) {
    return Object.keys(values).reduce(function(output, key) {
      return output.replaceAll('{' + key + '}', values[key]);
    }, template || '');
  }

  function roundToFive(value) {
    return Math.round(value / 5) * 5;
  }

  function baseTiming(method) {
    var base = BASE_TIMINGS[method];
    if (method === 'drip') return { bloom: base.bloom, total: base.total };
    if (method === 'french_press') return { steep: base.steep, total: base.total };
    return { total: base.total };
  }

  function normalizeTiming(method, recipe) {
    var total = roundedNumber(recipe.total);

    if (method === 'drip') {
      var bloom = roundedNumber(recipe.bloom);
      if (bloom === null || total === null || bloom < 15 || total <= bloom + 80) return baseTiming(method);
      return { bloom: Math.min(bloom, 120), total: Math.min(total, 600) };
    }

    if (method === 'french_press') {
      var steep = roundedNumber(recipe.steep);
      if (steep === null || total === null || steep < 60 || steep > 900 || total > 1200 || total - steep < 30 || total - steep > 60) return baseTiming(method);
      return { steep: steep, total: total };
    }

    if (total === null || total < 20 || total > 90) return baseTiming('espresso');
    return { total: Math.min(total, 90) };
  }

  function formatSeconds(seconds) {
    var safeSeconds = Math.max(0, seconds);
    var minutes = Math.floor(safeSeconds / 60);
    return minutes + ':' + String(safeSeconds % 60).padStart(2, '0');
  }

  function formatElapsed(seconds) {
    return formatSeconds(Math.floor(seconds));
  }

  function formatRemaining(seconds) {
    return formatSeconds(Math.ceil(seconds));
  }

  function addStage(stages, details, end) {
    var start = stages.length ? stages[stages.length - 1].end : 0;
    if (end > start) stages.push(Object.assign({ start: start, end: end }, details));
  }

  function setTextIfChanged(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }

  function setHidden(element, hidden) {
    element.toggleAttribute('hidden', Boolean(hidden));
  }

  function normalizeDripWeights(recipe) {
    var dose = roundedNumber(recipe.doseGrams);
    var water = roundedNumber(recipe.waterGrams);
    var bloom = roundedNumber(recipe.bloomGrams);

    if (dose === null || dose < 5 || dose > 100 || water === null || water < 100 || water > 1000) return null;
    if (bloom === null) bloom = roundToFive(water / 6);
    if (bloom < 20 || bloom > 200 || bloom >= water) return null;

    return { dose: dose, water: water, bloom: bloom };
  }

  function normalizeFrenchPressWeights(recipe) {
    var dose = roundedNumber(recipe.doseGrams);
    var water = roundedNumber(recipe.waterGrams);
    if (dose === null || dose < 5 || dose > 100 || water === null || water < 100 || water > 1500) {
      return { dose: 30, water: 450 };
    }
    return { dose: dose, water: water };
  }

  function normalizeEspressoWeights(recipe) {
    var dose = numericNumber(recipe.doseGrams);
    var output = numericNumber(recipe.yieldGrams);
    if (dose === null || dose < 5 || dose > 40 || output === null || output < 10 || output > 100) return null;
    return { dose: dose, output: output };
  }

  function dripTargetWeights(weights) {
    var remaining = weights.water - weights.bloom;
    var first = roundToFive(weights.bloom + (remaining * 0.4));
    var second = roundToFive(weights.bloom + (remaining * 0.8));

    first = Math.min(weights.water - 10, Math.max(weights.bloom + 5, first));
    second = Math.min(weights.water - 5, Math.max(first + 5, second));
    return [weights.bloom, first, second, weights.water];
  }

  function addDripSubphase(stages, details, end, targetWeight, previousWeight) {
    var start = stages.length ? stages[stages.length - 1].end : 0;
    if (end <= start) return;
    var targetFlow = details.action === 'pour' ? (targetWeight - previousWeight) / (end - start) : null;
    stages.push(Object.assign({
      start: start,
      end: end,
      targetWeight: targetWeight,
      targetFlow: targetFlow
    }, details));
  }

  function dripCadence(timing) {
    var previousMiddlePourDuration = 15;
    var middleDrawdownDuration = 15;
    var previousMiddlePhaseDuration = previousMiddlePourDuration + middleDrawdownDuration;
    var previousFinalPhaseStart = timing.bloom + (previousMiddlePhaseDuration * 2);
    var previousFinalPhaseDuration = timing.total - previousFinalPhaseStart;
    var availableExtension = Math.max(0, Math.floor((previousFinalPhaseDuration - 2) / 2));
    var middlePourDuration = previousMiddlePourDuration + Math.min(previousMiddlePourDuration, availableExtension);
    var firstPourEnd = timing.bloom + middlePourDuration;
    var firstPhaseEnd = firstPourEnd + middleDrawdownDuration;
    var secondPourEnd = firstPhaseEnd + middlePourDuration;
    var secondPhaseEnd = secondPourEnd + middleDrawdownDuration;
    var finalPourStart = secondPhaseEnd;
    var finalPhaseDuration = timing.total - finalPourStart;
    var finalPourDuration = Math.round(finalPhaseDuration * 0.6);
    var finalPourEnd = finalPourStart + finalPourDuration;

    return {
      firstPourEnd: firstPourEnd,
      firstPhaseEnd: firstPhaseEnd,
      secondPourEnd: secondPourEnd,
      secondPhaseEnd: secondPhaseEnd,
      finalPourEnd: finalPourEnd
    };
  }

  function buildWeightGuidedDripStages(copy, labels, timing, weights) {
    var stages = [];
    var targets = dripTargetWeights(weights);
    var bloomPourEnd = Math.round(timing.bloom * 0.5);
    var cadence = dripCadence(timing);
    var phases = [
      { id: 'bloom', copy: copy.bloom, start: 0, pourEnd: bloomPourEnd, end: timing.bloom, target: targets[0], previous: 0 },
      { id: 'pour_one', copy: copy.pourOne, start: timing.bloom, pourEnd: cadence.firstPourEnd, end: cadence.firstPhaseEnd, target: targets[1], previous: targets[0] },
      { id: 'pour_two', copy: copy.pourTwo, start: cadence.firstPhaseEnd, pourEnd: cadence.secondPourEnd, end: cadence.secondPhaseEnd, target: targets[2], previous: targets[1] },
      { id: 'pour_three', copy: copy.pourThree, start: cadence.secondPhaseEnd, pourEnd: cadence.finalPourEnd, end: timing.total, target: targets[3], previous: targets[2] }
    ];

    phases.forEach(function(phase, phaseIndex) {
      addDripSubphase(stages, {
        id: phase.id + '_pour',
        phaseId: phase.id,
        phaseIndex: phaseIndex,
        phaseCount: phases.length,
        action: 'pour',
        tone: 'water',
        title: phase.copy.title,
        instruction: phase.copy.instruction
      }, phase.pourEnd, phase.target, phase.previous);
      addDripSubphase(stages, {
        id: phase.id + '_drawdown',
        phaseId: phase.id,
        phaseIndex: phaseIndex,
        phaseCount: phases.length,
        action: 'drawdown',
        tone: 'rest',
        title: phase.copy.title,
        instruction: phaseIndex === phases.length - 1 ? copy.drawdown.instruction : labels.drawdownInstruction
      }, phase.end, phase.target, phase.target);
    });

    return stages;
  }

  function buildStages(method, recipe, copy, labels) {
    var stages = [];
    var timing = normalizeTiming(method, recipe);
    var total = timing.total;

    if (method === 'drip') {
      var bloom = timing.bloom;
      var weights = normalizeDripWeights(recipe);
      if (weights) return buildWeightGuidedDripStages(copy, labels, timing, weights);
      var cadence = dripCadence(timing);
      addStage(stages, { id: 'bloom', title: copy.bloom.title, instruction: copy.bloom.instruction }, Math.min(bloom, total));
      addStage(stages, { id: 'pour_one', title: copy.pourOne.title, instruction: copy.pourOne.instruction }, Math.min(cadence.firstPhaseEnd, total));
      addStage(stages, { id: 'pour_two', title: copy.pourTwo.title, instruction: copy.pourTwo.instruction }, Math.min(cadence.secondPhaseEnd, total));
      addStage(stages, { id: 'pour_three', title: copy.pourThree.title, instruction: copy.pourThree.instruction }, Math.min(cadence.finalPourEnd, total));
      addStage(stages, { id: 'drawdown', title: copy.drawdown.title, instruction: copy.drawdown.instruction }, total);
    } else if (method === 'french_press') {
      var steep = timing.steep;
      addStage(stages, { id: 'pour', action: 'pour', tone: 'water', title: copy.pour.title, instruction: copy.pour.instruction }, Math.min(20, total));
      addStage(stages, { id: 'stir', action: 'stir', tone: 'water-soft', title: copy.stir.title, instruction: copy.stir.instruction }, Math.min(35, total));
      addStage(stages, { id: 'steep', action: 'steep', tone: 'water-muted', title: copy.steep.title, instruction: copy.steep.instruction }, Math.min(steep, total));
      addStage(stages, { id: 'press', action: 'press', tone: 'water-deep', title: copy.press.title, instruction: copy.press.instruction }, total);
    } else {
      var finish = total - 8;
      addStage(stages, { id: 'first_drops', action: 'espresso', tone: 'water-soft', title: copy.firstDrops.title, instruction: copy.firstDrops.instruction }, 8);
      addStage(stages, { id: 'flow', action: 'espresso', tone: 'water', title: copy.flow.title, instruction: copy.flow.instruction }, finish);
      addStage(stages, { id: 'finish', action: 'espresso', tone: 'water-deep', title: copy.finish.title, instruction: copy.finish.instruction }, total);
    }

    return stages;
  }

  function BrewTimer(root) {
    this.root = root;
    this.config = this.readConfig();
    this.method = this.config.defaultMethod in this.config.methods ? this.config.defaultMethod : 'drip';
    this.elapsed = 0;
    this.startedAt = 0;
    this.running = false;
    this.complete = false;
    this.stopElapsed = null;
    this.cuesEnabled = false;
    this.frame = null;
    this.lastStageIndex = -1;
    this.lastGuidanceKey = null;
    this.targetCueFired = false;
    this.audioContext = null;
    this.announcementTimeout = null;
    this.abortController = new AbortController();
    this.instructionFitCache = {};
    this.cacheElements();
    this.bindEvents();
    this.setMethodPickerExpanded(true, false);
    this.selectMethod(this.method, false);
  }

  BrewTimer.prototype.readConfig = function() {
    var element = this.root.querySelector('[data-brew-timer-config]');
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('Coffee brew timer configuration is invalid.', error);
      return { defaultMethod: 'drip', labels: {}, methods: {} };
    }
  };

  BrewTimer.prototype.cacheElements = function() {
    this.methodPicker = this.root.querySelector('[data-brew-method-picker]');
    this.methodOptions = this.root.querySelector('[data-brew-method-options]');
    this.currentMethodButton = this.root.querySelector('[data-brew-current-method]');
    this.methodIcons = Array.from(this.root.querySelectorAll('[data-brew-method-icon]'));
    this.methodButtons = Array.from(this.root.querySelectorAll('[data-brew-method]'));
    this.ringSegments = this.root.querySelector('[data-brew-segments]');
    this.progress = this.root.querySelector('[data-brew-progress]');
    this.prepRow = this.root.querySelector('[data-brew-prep-row]');
    this.prepLabel = this.root.querySelector('[data-brew-prep-label]');
    this.prepTarget = this.root.querySelector('[data-brew-prep-target]');
    this.prepDetails = this.root.querySelector('[data-brew-prep-details]');
    this.prepDuration = this.root.querySelector('[data-brew-prep-duration]');
    this.prepTemperature = this.root.querySelector('[data-brew-prep-temperature]');
    this.ringAction = this.root.querySelector('[data-brew-ring-action]');
    this.ringActionLabel = this.root.querySelector('[data-brew-ring-action-label]');
    this.ringPourIcon = this.root.querySelector('[data-brew-ring-pour]');
    this.ringDrawdownIcon = this.root.querySelector('[data-brew-ring-drawdown]');
    this.ringCompleteIcon = this.root.querySelector('[data-brew-ring-complete]');
    this.weight = this.root.querySelector('[data-brew-weight]');
    this.weightValue = this.root.querySelector('[data-brew-weight-value]');
    this.paceRow = this.root.querySelector('[data-brew-pace-row]');
    this.actionHelp = this.root.querySelector('[data-brew-action-help]');
    this.paceHelp = this.root.querySelector('[data-brew-pace-help]');
    this.targetPace = this.root.querySelector('[data-brew-target-pace]');
    this.time = this.root.querySelector('[data-brew-time]');
    this.timeRow = this.root.querySelector('.coffee-brew-timer__time-row');
    this.total = this.root.querySelector('[data-brew-total]');
    this.espressoTarget = this.root.querySelector('[data-brew-espresso-target]');
    this.weightStatus = this.root.querySelector('[data-brew-weight-status]');
    this.stageCount = this.root.querySelector('[data-brew-stage-count]');
    this.stageTitle = this.root.querySelector('[data-brew-stage-title]');
    this.instruction = this.root.querySelector('[data-brew-instruction]');
    this.stageTime = this.root.querySelector('[data-brew-stage-time]');
    this.primary = this.root.querySelector('[data-brew-primary]');
    this.primaryLabel = this.root.querySelector('[data-brew-primary-label]');
    this.primaryStartIcon = this.root.querySelector('[data-brew-primary-start]');
    this.primaryPauseIcon = this.root.querySelector('[data-brew-primary-pause]');
    this.primaryStopIcon = this.root.querySelector('[data-brew-primary-stop]');
    this.primaryRestartIcon = this.root.querySelector('[data-brew-primary-restart]');
    this.previous = this.root.querySelector('[data-brew-previous]');
    this.next = this.root.querySelector('[data-brew-next]');
    this.resetButton = this.root.querySelector('[data-brew-reset]');
    this.cuesButton = this.root.querySelector('[data-brew-cues]');
    this.cueLabel = this.root.querySelector('[data-brew-cue-label]');
    this.methodTitle = this.root.querySelector('[data-brew-method-title]');
    this.specs = this.root.querySelector('[data-brew-specs]');
    this.recipeNote = this.root.querySelector('[data-brew-recipe-note]');
    this.recipeNoteTitle = this.root.querySelector('[data-brew-recipe-note-title]');
    this.recipeNoteCopy = this.root.querySelector('[data-brew-recipe-note-copy]');
    this.troubleshooting = this.root.querySelector('[data-brew-troubleshooting]');
    this.troubleshootingTitle = this.root.querySelector('[data-brew-troubleshooting-title]');
    this.troubleshootingItems = this.root.querySelector('[data-brew-troubleshooting-items]');
    this.helpDialog = this.root.querySelector('[data-brew-help-dialog]');
    this.helpTitle = this.root.querySelector('[data-brew-help-title]');
    this.helpCopy = this.root.querySelector('[data-brew-help-copy]');
    this.helpClose = this.root.querySelector('[data-brew-help-close]');
    this.helpOpener = null;
    this.stepsList = this.root.querySelector('[data-brew-steps]');
    this.status = this.root.querySelector('[data-brew-status]');
    this.progress.style.strokeDasharray = CIRCUMFERENCE;
    this.segmentElements = [];
  };

  BrewTimer.prototype.bindEvents = function() {
    var self = this;
    var signal = this.abortController.signal;

    this.methodPicker.addEventListener('pointerdown', function() {
      self.methodPicker.dataset.pointerFocus = 'true';
    }, { signal: signal });
    window.addEventListener('keydown', function() {
      delete self.methodPicker.dataset.pointerFocus;
    }, { signal: signal });

    this.methodButtons.forEach(function(button, index) {
      button.addEventListener('click', function() {
        self.selectMethod(button.dataset.brewMethod, true);
        self.setMethodPickerExpanded(false, true);
      }, { signal: signal });
      button.addEventListener('keydown', function(event) {
        if (button.disabled) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        var targetIndex = index;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + self.methodButtons.length) % self.methodButtons.length;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % self.methodButtons.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = self.methodButtons.length - 1;
        self.methodButtons[targetIndex].focus();
        self.selectMethod(self.methodButtons[targetIndex].dataset.brewMethod, true);
      }, { signal: signal });
    });

    this.currentMethodButton.addEventListener('click', function() {
      self.setMethodPickerExpanded(true, true);
    }, { signal: signal });

    this.primary.addEventListener('click', function() { self.toggle(); }, { signal: signal });
    this.previous.addEventListener('click', function() { self.moveStage(-1); }, { signal: signal });
    this.next.addEventListener('click', function() { self.moveStage(1); }, { signal: signal });
    this.resetButton.addEventListener('click', function() { self.reset(); }, { signal: signal });
    this.cuesButton.addEventListener('click', function() { self.toggleCues(); }, { signal: signal });
    var refreshFit = function() {
      self.instructionFitCache = {};
      self.fitPrepTarget();
      self.render();
    };
    window.addEventListener('resize', refreshFit, { signal: signal });
    if (document.fonts && document.fonts.addEventListener) {
      document.fonts.addEventListener('loadingdone', refreshFit, { signal: signal });
    }
    this.root.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-brew-help]');
      if (trigger && self.root.contains(trigger)) self.openHelp(trigger);
    }, { signal: signal });
    this.helpClose.addEventListener('click', function() { self.closeHelp(true); }, { signal: signal });
    this.helpDialog.addEventListener('cancel', function(event) {
      event.preventDefault();
      self.closeHelp(true);
    }, { signal: signal });
    this.helpDialog.addEventListener('click', function(event) {
      if (event.target !== self.helpDialog) return;
      var rect = self.helpDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) self.closeHelp(true);
    }, { signal: signal });
  };

  BrewTimer.prototype.setMethodPickerExpanded = function(expanded, moveFocus) {
    this.methodPicker.dataset.expanded = String(expanded);
    this.currentMethodButton.setAttribute('aria-expanded', String(expanded));
    if (expanded) {
      this.methodOptions.inert = false;
      this.methodOptions.removeAttribute('aria-hidden');
      if (moveFocus) {
        this.methodButtons.find(function(button) { return button.dataset.brewMethod === this.method; }, this).focus({ preventScroll: true });
      }
      this.currentMethodButton.setAttribute('tabindex', '-1');
      this.currentMethodButton.setAttribute('aria-hidden', 'true');
    } else {
      this.currentMethodButton.removeAttribute('tabindex');
      this.currentMethodButton.removeAttribute('aria-hidden');
      if (moveFocus) this.currentMethodButton.focus({ preventScroll: true });
      this.methodOptions.inert = true;
      this.methodOptions.setAttribute('aria-hidden', 'true');
    }
  };

  BrewTimer.prototype.renderCurrentMethod = function() {
    this.currentMethodButton.setAttribute('aria-label', replaceTokens(this.config.labels.currentMethod, { method: this.recipe.label }));
    var selectedMethod = this.method;
    this.methodIcons.forEach(function(icon) { setHidden(icon, icon.dataset.brewMethodIcon !== selectedMethod); });
  };

  BrewTimer.prototype.helpTopic = function(topic) {
    if (topic === 'ratio' && this.method === 'espresso') return 'dose_yield';
    if (topic === 'grind' && this.method === 'espresso') return 'espresso_grind';
    if (topic === 'grind' && this.method === 'french_press') return 'press_grind';
    return topic;
  };

  BrewTimer.prototype.updateHelpLabel = function(button) {
    var entry = this.config.help[this.helpTopic(button.dataset.brewHelp)];
    if (entry) button.setAttribute('aria-label', replaceTokens(this.config.labels.helpAbout, { topic: entry.title }));
  };

  BrewTimer.prototype.createHelp = function(topic) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'coffee-brew-timer__help';
    button.dataset.brewHelp = topic;
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', this.helpDialog.id);
    var icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'i';
    button.appendChild(icon);
    this.updateHelpLabel(button);
    return button;
  };

  BrewTimer.prototype.openHelp = function(trigger) {
    var entry = this.config.help[this.helpTopic(trigger.dataset.brewHelp)];
    if (!entry || typeof this.helpDialog.showModal !== 'function') return;
    this.helpTitle.textContent = entry.title;
    this.helpCopy.textContent = entry.body;
    this.helpOpener = trigger;
    if (!this.helpDialog.open) this.helpDialog.showModal();
    this.helpTitle.focus({ preventScroll: true });
  };

  BrewTimer.prototype.closeHelp = function(restoreFocus) {
    var opener = this.helpOpener;
    this.helpOpener = null;
    if (this.helpDialog.open) this.helpDialog.close();
    if (restoreFocus) {
      var target = opener && opener.isConnected && !opener.closest('[hidden]') && !opener.disabled ? opener : this.primary;
      if (target.isConnected) target.focus({ preventScroll: true });
    }
  };

  BrewTimer.prototype.renderHelp = function(prepState, stage, showTarget) {
    var key = this.method + ':' + stage.id + ':' + prepState + ':' + this.complete;
    if (key === this.helpStateKey) return;
    this.helpStateKey = key;
    var topic = stage.action === 'drawdown' ? 'drawdown' : (this.method === 'espresso' ? 'espresso_target' : 'water_target');
    this.actionHelp.dataset.brewHelp = topic;
    setHidden(this.actionHelp, prepState || this.complete || !showTarget);
    setHidden(this.paceHelp, prepState || this.complete || !this.weightGuided || stage.action !== 'pour');
    var self = this;
    this.root.querySelectorAll('[data-brew-help]').forEach(function(button) {
      self.updateHelpLabel(button);
      button.disabled = typeof self.helpDialog.showModal !== 'function';
    });
  };

  BrewTimer.prototype.renderTroubleshooting = function() {
    this.troubleshooting.open = false;
    this.troubleshootingTitle.textContent = this.recipe.refineTitle || replaceTokens(this.config.labels.troubleshootingTitle, { method: this.recipe.label });
    this.troubleshootingItems.replaceChildren();
    var self = this;
    Object.values(this.config.troubleshooting[this.method]).forEach(function(entry) {
      var group = document.createElement('div');
      var symptom = document.createElement('dt');
      var advice = document.createElement('dd');
      symptom.textContent = entry.symptom;
      advice.textContent = entry.advice;
      group.append(symptom, advice);
      self.troubleshootingItems.appendChild(group);
    });
  };

  BrewTimer.prototype.fitPrepTarget = function() {
    if (!this.prepTarget || this.prepTarget.hidden) return;

    this.prepTarget.style.removeProperty('--brew-prep-target-size');
    var baseSize = parseFloat(window.getComputedStyle(this.prepTarget).fontSize);
    var availableWidth = this.prepTarget.parentElement.clientWidth * 0.8;
    var contentWidth = this.prepTarget.scrollWidth;
    if (!baseSize || !availableWidth || !contentWidth) return;

    var fittedSize = Math.min(baseSize, baseSize * availableWidth / contentWidth);
    this.prepTarget.style.setProperty('--brew-prep-target-size', fittedSize + 'px');
  };

  BrewTimer.prototype.selectMethod = function(method, announce) {
    if (!this.config.methods[method]) return;
    if (method === this.method && this.stages) return;
    this.closeHelp(false);
    this.pause();
    this.method = method;
    this.root.dataset.brewMethodActive = method;
    this.recipe = this.config.methods[method];
    this.instructionFitCache = {};
    this.stages = buildStages(method, this.recipe, this.config.stages[method], this.config.labels);
    this.weightGuided = method === 'drip' && this.stages.some(function(stage) { return Boolean(stage.action); });
    this.dripWeights = method === 'drip' ? normalizeDripWeights(this.recipe) : null;
    this.frenchPressWeights = method === 'french_press' ? normalizeFrenchPressWeights(this.recipe) : null;
    this.espressoWeights = method === 'espresso' ? normalizeEspressoWeights(this.recipe) : null;
    this.segmentedRing = this.weightGuided || method === 'french_press' || method === 'espresso';
    this.duration = normalizeTiming(method, this.recipe).total;
    this.elapsed = 0;
    this.complete = false;
    this.stopElapsed = null;
    this.lastStageIndex = -1;
    this.lastGuidanceKey = null;
    this.targetCueFired = false;
    var selectedIndex = 0;

    this.methodButtons.forEach(function(button, index) {
      var selected = button.dataset.brewMethod === method;
      button.setAttribute('aria-pressed', String(selected));
      if (selected) selectedIndex = index;
    });
    this.root.style.setProperty('--brew-method-position', (selectedIndex * 100) + '%');

    this.renderCurrentMethod();
    this.renderRingSchedule();
    this.renderRecipe();
    this.renderTroubleshooting();
    this.render();
    if (announce) this.announce(this.recipe.label + '. ' + this.config.labels.recipe + ' ' + formatElapsed(this.duration) + '.');
  };

  BrewTimer.prototype.renderRingSchedule = function() {
    var self = this;
    this.ringSegments.replaceChildren();
    this.segmentElements = [];
    setHidden(this.progress, this.segmentedRing);
    this.root.classList.toggle('is-weight-guided', this.weightGuided);
    this.root.classList.toggle('is-segmented', this.segmentedRing);

    if (!this.segmentedRing) return;

    this.stages.forEach(function(stage) {
      var segmentLength = CIRCUMFERENCE * ((stage.end - stage.start) / self.duration);
      var visibleLength = Math.max(1, segmentLength - RING_SEGMENT_GAP);
      var startLength = CIRCUMFERENCE * (stage.start / self.duration);
      var base = document.createElementNS(SVG_NAMESPACE, 'circle');
      var elapsed = document.createElementNS(SVG_NAMESPACE, 'circle');
      var actionClass = stage.action === 'drawdown' ? 'is-drawdown' : (stage.action === 'pour' ? 'is-pour' : 'is-action');
      var toneClass = 'is-tone-' + (stage.tone || (stage.action === 'drawdown' ? 'rest' : 'water'));

      [base, elapsed].forEach(function(circle) {
        circle.setAttribute('cx', '110');
        circle.setAttribute('cy', '110');
        circle.setAttribute('r', '99');
        circle.style.strokeDashoffset = String(-startLength);
      });
      base.setAttribute('class', 'coffee-brew-timer__ring-segment ' + actionClass + ' ' + toneClass);
      base.style.strokeDasharray = visibleLength + ' ' + (CIRCUMFERENCE - visibleLength);
      elapsed.setAttribute('class', 'coffee-brew-timer__ring-segment-progress ' + actionClass + ' ' + toneClass);
      elapsed.style.strokeDasharray = '0 ' + CIRCUMFERENCE;
      setHidden(elapsed, true);
      self.ringSegments.append(base, elapsed);
      self.segmentElements.push({
        stage: stage,
        base: base,
        progress: elapsed,
        visibleLength: visibleLength
      });
    });
  };

  BrewTimer.prototype.renderRing = function() {
    var self = this;
    if (!this.segmentedRing) {
      var progressRatio = Math.min(1, this.elapsed / this.duration);
      this.progress.style.strokeDashoffset = CIRCUMFERENCE * (1 - progressRatio);
      return;
    }

    this.segmentElements.forEach(function(segment) {
      var duration = segment.stage.end - segment.stage.start;
      var elapsedWithin = Math.min(duration, Math.max(0, self.elapsed - segment.stage.start));
      var visibleProgress = segment.visibleLength * (elapsedWithin / duration);
      var current = self.elapsed >= segment.stage.start && self.elapsed < segment.stage.end && !self.complete;
      var state = elapsedWithin >= duration ? 'complete' : (current ? 'active' : 'future');

      segment.base.dataset.state = state;
      setHidden(segment.progress, visibleProgress <= 0);
      segment.progress.style.strokeDasharray = visibleProgress + ' ' + (CIRCUMFERENCE - visibleProgress);
    });
  };

  BrewTimer.prototype.renderRecipe = function() {
    var self = this;
    var specs = [
      [this.config.labels.ratio, this.recipe.ratio],
      [this.config.labels.grind, this.recipe.grind],
      [this.config.labels.temperature, this.recipe.temperature],
      [this.config.labels.yield, this.recipe.yield]
    ];

    this.methodTitle.textContent = this.recipe.label + ' ' + this.config.labels.recipe;
    this.specs.replaceChildren();
    specs.forEach(function(spec) {
      var wrapper = document.createElement('div');
      var term = document.createElement('dt');
      var detail = document.createElement('dd');
      var label = document.createElement('span');
      label.className = 'coffee-brew-timer__help-anchor';
      label.textContent = spec[0];
      if (spec[0] === self.config.labels.grind) label.appendChild(self.createHelp('grind'));
      if (spec[0] === self.config.labels.temperature) label.appendChild(self.createHelp('temperature'));
      term.appendChild(label);
      detail.textContent = spec[1] || '—';
      wrapper.append(term, detail);
      self.specs.appendChild(wrapper);
    });

    var showRecipeNote = this.method === 'espresso' && Boolean(this.recipe.note);
    setHidden(this.recipeNote, !showRecipeNote);
    if (showRecipeNote) {
      this.recipeNoteTitle.textContent = this.config.labels.coffeeGuidance;
      this.recipeNoteCopy.textContent = this.recipe.note;
    } else {
      this.recipeNoteCopy.textContent = '';
    }

    this.stepsList.replaceChildren();
    if (this.weightGuided) {
      var phases = [];
      this.stages.forEach(function(stage) {
        var phase = phases[stage.phaseIndex];
        if (!phase) {
          phase = { title: stage.title, start: stage.start, end: stage.end, stages: [] };
          phases[stage.phaseIndex] = phase;
        }
        phase.end = stage.end;
        phase.stages.push(stage);
      });
      phases.forEach(function(phase) {
        var item = document.createElement('li');
        var heading = document.createElement('div');
        var name = document.createElement('span');
        var timing = document.createElement('span');
        var details = document.createElement('p');
        var pourStage = phase.stages[0];
        var drawdownStage = phase.stages[1];

        item.className = 'coffee-brew-timer__weight-step';
        heading.className = 'coffee-brew-timer__step-heading';
        name.textContent = phase.title;
        timing.textContent = formatElapsed(phase.start) + '–' + formatElapsed(phase.end);
        details.className = 'coffee-brew-timer__step-details';
        details.textContent = self.config.labels.pourTo + ' ' + pourStage.targetWeight + 'g ' +
          formatElapsed(pourStage.start) + '–' + formatElapsed(pourStage.end) + ' · ' +
          self.config.labels.pauseAction + ' ' + formatElapsed(drawdownStage.start) + '–' + formatElapsed(drawdownStage.end);
        heading.append(name, timing);
        item.append(heading, details);
        self.stepsList.appendChild(item);
      });
      return;
    }

    this.stages.forEach(function(stage) {
      var item = document.createElement('li');
      var name = document.createElement('span');
      var timing = document.createElement('span');
      name.textContent = stage.title;
      timing.textContent = formatElapsed(stage.start) + '–' + formatElapsed(stage.end);
      item.append(name, timing);
      self.stepsList.appendChild(item);
    });

  };

  BrewTimer.prototype.getStageIndex = function() {
    if (this.complete) return this.stages.length - 1;
    for (var i = 0; i < this.stages.length; i += 1) {
      if (this.elapsed < this.stages[i].end) return i;
    }
    return this.stages.length - 1;
  };

  BrewTimer.prototype.getStageAnnouncement = function(stage) {
    var resolved = this.getActiveInstruction(stage);
    if (this.method === 'espresso') {
      return stage.title + '. ' + (this.espressoWeights ? this.config.labels.target + ' ' + formatNumber(this.espressoWeights.output) + ' grams. ' : '') + replaceTokens(resolved, {
        yield: this.espressoWeights ? formatNumber(this.espressoWeights.output) : ''
      });
    }
    if (!this.weightGuided) return stage.title + '. ' + resolved;
    if (stage.action === 'pour') return this.config.labels.pourTo + ' ' + stage.targetWeight + ' grams. ' + resolved;
    return this.config.labels.pauseAction + '. ' + this.config.labels.holdAt + ' ' + stage.targetWeight + ' grams. ' + resolved;
  };

  // Approved narration is plain text, not a template or HTML surface.
  BrewTimer.prototype.resolveInstruction = function(state, fallback) {
    var map = this.recipe.instructions;
    var text = map && typeof map === 'object' && !Array.isArray(map) && map[state];
    if (typeof text !== 'string' || !text.trim() || text.length > 72 || /[{}<>]/.test(text)) return fallback;
    text = text.trim();
    var key = JSON.stringify([state, text]);
    if (key in this.instructionFitCache) return this.instructionFitCache[key] ? text : fallback;
    var width = this.instruction.clientWidth;
    var style = window.getComputedStyle(this.instruction);
    var lineHeight = parseFloat(style.lineHeight);
    // At enlarged text sizes allow readable reflow rather than hiding guidance.
    if (!width || !lineHeight || parseFloat(style.fontSize) > 18) return text;
    if (!(key in this.instructionFitCache)) {
      var probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;display:block;height:auto;min-height:0;max-height:none;padding:0;border:0;white-space:normal;overflow:visible;';
      probe.style.width = width + 'px';
      probe.style.font = style.font;
      probe.style.lineHeight = style.lineHeight;
      probe.style.letterSpacing = style.letterSpacing;
      probe.textContent = text;
      this.root.appendChild(probe);
      this.instructionFitCache[key] = probe.getBoundingClientRect().height <= lineHeight * 2 + 1 && probe.scrollWidth <= width + 1;
      probe.remove();
    }
    return this.instructionFitCache[key] ? text : fallback;
  };

  BrewTimer.prototype.getActiveInstruction = function(stage) {
    if (this.method === 'french_press') return this.getFrenchPressInstruction(stage);
    if (this.method === 'espresso' && stage.id === 'finish' && !this.espressoWeights) return this.config.labels.espressoFinishTimeOnly;
    // Time-only pour-over stages have no cumulative target for custom pour copy.
    if (this.method === 'drip' && !this.weightGuided) return stage.instruction;
    return this.resolveInstruction(stage.id, replaceTokens(stage.instruction, {
      yield: this.espressoWeights ? formatNumber(this.espressoWeights.output) : ''
    }));
  };

  BrewTimer.prototype.getFrenchPressInstruction = function(stage) {
    if (stage.id === 'steep') {
      var secondsBeforePress = stage.end - this.elapsed;
      if (secondsBeforePress <= 30) return this.resolveInstruction('steep_ready', this.config.labels.steepReady);
      if (!this.recipe.instructions && this.elapsed >= 60 && this.recipe.coffeeMessage) return this.recipe.coffeeMessage;
    }
    if (stage.id === 'press') {
      return this.elapsed < stage.start + 20 ? this.resolveInstruction('press', this.config.labels.pressInstruction) : this.resolveInstruction('decant', this.config.labels.decantInstruction);
    }
    return this.resolveInstruction(stage.id, stage.instruction);
  };

  BrewTimer.prototype.getEspressoSummary = function() {
    var stopped = this.stopElapsed === null ? this.elapsed : this.stopElapsed;
    var summary = this.config.labels.timerStoppedAt + ' ' + formatElapsed(stopped);
    if (this.espressoWeights) summary += ' · ' + this.config.labels.target + ' ' + formatNumber(this.espressoWeights.output) + 'g';
    return summary;
  };

  BrewTimer.prototype.shouldCueForStage = function(stage) {
    if (this.method === 'espresso') return stage.id === 'finish';
    if (this.method === 'french_press') return stage.id === 'stir' || stage.id === 'press';
    return true;
  };

  BrewTimer.prototype.render = function() {
    var stageIndex = this.getStageIndex();
    var stage = this.stages[stageIndex];
    var nextStage = this.stages[stageIndex + 1];
    var stageRemaining = Math.max(0, stage.end - this.elapsed);
    var readyState = this.elapsed === 0 && !this.running && !this.complete;
    var prepState = readyState && ((this.method === 'drip' && this.dripWeights) || this.method === 'french_press' || (this.method === 'espresso' && this.espressoWeights));
    var frenchPourTarget = this.method === 'french_press' && !prepState && !this.complete && stage.id === 'pour';
    var espressoWeightTarget = this.method === 'espresso' && Boolean(this.espressoWeights) && !prepState && !this.complete;
    var nextAction = this.weightGuided ?
      (nextStage ? (nextStage.action === 'pour' ? this.config.labels.nextPour : this.config.labels.pauseAction) : this.config.labels.complete) :
      (nextStage ? nextStage.title : this.config.labels.complete);
    var displayStep = stage.phaseIndex === undefined ? stageIndex + 1 : stage.phaseIndex + 1;
    var displayStepCount = stage.phaseCount || this.stages.length;
    var methodRingAction = !prepState && !this.complete && (this.method === 'french_press' || this.method === 'espresso');
    var showRingAction = this.complete || (!prepState && (this.weightGuided || frenchPourTarget || methodRingAction));

    setTextIfChanged(this.time, formatElapsed(this.elapsed));
    setTextIfChanged(this.total, '/ ' + (this.method === 'espresso' ? this.config.labels.target + ' ' : '') + formatElapsed(this.duration));
    this.renderRing();
    setHidden(this.prepRow, !prepState);
    setHidden(this.prepTarget, !prepState);
    setHidden(this.prepDetails, !prepState);
    setHidden(this.timeRow, prepState);
    if (!prepState) this.prepTarget.style.removeProperty('--brew-prep-target-size');
    if (prepState) {
      if (this.method === 'drip') {
        this.prepLabel.textContent = this.config.labels.coffeeWater;
        this.prepTarget.textContent = this.dripWeights.dose + 'g : ' + this.dripWeights.water + 'g';
        setTextIfChanged(this.instruction, this.resolveInstruction('prep', replaceTokens(this.config.labels.dripPrep, { dose: this.dripWeights.dose })));
        this.stageTime.textContent = this.config.labels.dripStartTiming;
      } else if (this.method === 'french_press') {
        this.prepLabel.textContent = this.config.labels.coffeeWater;
        this.prepTarget.textContent = this.frenchPressWeights.dose + 'g : ' + this.frenchPressWeights.water + 'g';
        setTextIfChanged(this.instruction, this.resolveInstruction('prep', replaceTokens(this.config.labels.frenchPressPrep, { dose: this.frenchPressWeights.dose })));
        this.stageTime.textContent = this.config.labels.frenchPressStartTiming;
      } else {
        this.prepLabel.textContent = this.config.labels.doseYield;
        this.prepTarget.textContent = formatNumber(this.espressoWeights.dose) + 'g : ' + formatNumber(this.espressoWeights.output) + 'g';
        setTextIfChanged(this.instruction, this.resolveInstruction('prep', replaceTokens(this.config.labels.espressoPrep, {
          dose: formatNumber(this.espressoWeights.dose)
        })));
        this.stageTime.textContent = this.config.labels.espressoStartTiming;
      }
      this.prepDuration.textContent = this.config.labels.totalBrewTime + ' · ' + formatElapsed(this.duration);
      this.prepTemperature.textContent = this.config.labels.waterTemperature + ' · ' + this.recipe.temperature;
      setHidden(this.prepTemperature, !this.recipe.temperature);
      this.stageTitle.textContent = this.config.labels.readyToBrew;
      this.fitPrepTarget();
    } else if (this.complete && this.method === 'espresso') {
      this.stageTitle.textContent = this.config.labels.shotComplete;
      setTextIfChanged(this.instruction, this.resolveInstruction('complete', this.config.labels.espressoReady));
      this.stageTime.textContent = this.getEspressoSummary();
    } else if (this.complete) {
      this.stageTitle.textContent = this.method === 'french_press' ? this.config.labels.frenchPressComplete : this.config.labels.complete;
      setTextIfChanged(this.instruction, this.resolveInstruction('complete', this.method === 'french_press' ? this.config.labels.frenchPressReady : this.config.labels.ready));
      this.stageTime.textContent = '';
    } else {
      this.stageTitle.textContent = stage.title;
      setTextIfChanged(this.instruction, this.getActiveInstruction(stage));
      if (this.method === 'french_press' && stage.id === 'press' && this.elapsed < stage.start + 20) {
        this.stageTime.textContent = this.config.labels.decant + ' ' + this.config.labels.nextIn + ' ' + formatRemaining((stage.start + 20) - this.elapsed);
      } else if (this.method === 'espresso' && stage.id === 'finish') {
        this.stageTime.textContent = this.config.labels.targetTime + ' ' + this.config.labels.nextIn + ' ' + formatRemaining(this.duration - this.elapsed);
      } else if (readyState && this.method === 'drip') {
        this.stageTime.textContent = this.config.labels.dripStartTiming;
      } else {
        this.stageTime.textContent = nextAction + ' ' + this.config.labels.nextIn + ' ' + formatRemaining(stageRemaining);
      }
    }
    setHidden(this.stageCount, false);
    if (prepState) {
      this.stageCount.textContent = replaceTokens(this.config.labels.setupForMethod, { method: this.recipe.label });
    } else if (this.complete) {
      this.stageCount.textContent = this.config.labels.guideComplete;
    } else {
      this.stageCount.textContent = this.config.labels.step + ' ' + displayStep + ' ' + this.config.labels.of + ' ' + displayStepCount;
    }
    this.weightStatus.textContent = this.weightGuided && !prepState && !this.complete ?
      (stage.action === 'pour' ? this.config.labels.pourTo : this.config.labels.holdAt) + ' ' + stage.targetWeight + ' grams.' :
      (frenchPourTarget ? this.config.labels.pourTo + ' ' + this.frenchPressWeights.water + ' grams.' :
        (espressoWeightTarget ? this.config.labels.stopAt + ' ' + formatNumber(this.espressoWeights.output) + ' grams.' : ''));
    setHidden(this.ringAction, !showRingAction);
    setHidden(this.weight, prepState || (!this.weightGuided && !frenchPourTarget && !espressoWeightTarget) || this.complete);
    setHidden(this.paceRow, prepState || !this.weightGuided || this.complete);
    setHidden(this.ringPourIcon, true);
    setHidden(this.ringDrawdownIcon, true);
    setHidden(this.ringCompleteIcon, !this.complete);
    if (!prepState && (this.weightGuided || frenchPourTarget || espressoWeightTarget) && !this.complete) {
      var pouring = frenchPourTarget || stage.action === 'pour';
      this.ringActionLabel.textContent = espressoWeightTarget ? this.config.labels.stopAt :
        (frenchPourTarget || pouring ? this.config.labels.pourTo : this.config.labels.pauseAction);
      this.weightValue.textContent = espressoWeightTarget ? formatNumber(this.espressoWeights.output) :
        (frenchPourTarget ? this.frenchPressWeights.water : stage.targetWeight);
      setHidden(this.ringPourIcon, espressoWeightTarget || !pouring);
      setHidden(this.ringDrawdownIcon, espressoWeightTarget || pouring);
      if (this.weightGuided) this.targetPace.textContent = pouring ?
        this.config.labels.targetPace + ' ' + stage.targetFlow.toFixed(1) + ' g/s' :
        this.config.labels.holdAt + ' ' + stage.targetWeight + 'g';
    } else if (this.complete) {
      this.ringActionLabel.textContent = this.method === 'espresso' ? this.config.labels.shotComplete :
        (this.method === 'french_press' ? this.config.labels.frenchPressComplete : this.config.labels.complete);
    } else if (methodRingAction) {
      if (this.method === 'french_press' && stage.id === 'press' && this.elapsed >= stage.start + 20) {
        this.ringActionLabel.textContent = this.config.labels.decant;
      } else if (this.method === 'espresso' && stage.id === 'finish' && this.espressoWeights) {
        this.ringActionLabel.textContent = this.config.labels.stopAt;
      } else {
        this.ringActionLabel.textContent = stage.title;
      }
      setHidden(this.ringPourIcon, !(this.method === 'french_press' && stage.id === 'pour'));
    }
    this.renderHelp(prepState, stage, this.weightGuided || frenchPourTarget || espressoWeightTarget);
    setHidden(this.espressoTarget, true);
    setHidden(this.previous, this.method === 'espresso');
    setHidden(this.next, this.method === 'espresso');
    this.previous.disabled = stageIndex === 0;
    this.next.disabled = this.complete || stageIndex === this.stages.length - 1;
    this.primaryLabel.textContent = this.complete ? this.config.labels.restart :
      (this.method === 'espresso' ? (this.running ? this.config.labels.stopTimer : this.config.labels.startShot) :
        (this.running ? this.config.labels.pause : (this.elapsed > 0 ? this.config.labels.resume : this.config.labels.start)));
    setHidden(this.primaryStartIcon, this.running || this.complete);
    setHidden(this.primaryPauseIcon, !this.running || this.method === 'espresso');
    setHidden(this.primaryStopIcon, !this.running || this.method !== 'espresso');
    setHidden(this.primaryRestartIcon, !this.complete);
    this.root.classList.toggle('is-running', this.running);
    this.root.classList.toggle('is-complete', this.complete);
    this.root.dataset.brewStageTone = this.complete ? 'complete' : (stage.tone || 'water');
    this.root.classList.toggle('is-pouring', !prepState && !this.complete && ((this.weightGuided && stage.action === 'pour') || frenchPourTarget));
    this.root.classList.toggle('is-drawing-down', !prepState && this.weightGuided && !this.complete && stage.action === 'drawdown');
    this.root.classList.toggle('is-target-guided', frenchPourTarget);
    this.root.classList.toggle('is-espresso-target', espressoWeightTarget);
    this.root.classList.toggle('has-started', this.running || this.elapsed > 0 || this.complete);

    if (stageIndex !== this.lastStageIndex) {
      if (this.lastStageIndex >= 0 && this.running && this.shouldCueForStage(stage)) {
        this.cue();
        this.announce(this.getStageAnnouncement(stage));
      }
      this.lastStageIndex = stageIndex;
      this.lastGuidanceKey = this.method === 'french_press' && stage.id === 'press' ? 'press' : stage.id;
    } else if (this.method === 'french_press' && stage.id === 'press') {
      var guidanceKey = this.elapsed < stage.start + 20 ? 'press' : 'decant';
      if (this.lastGuidanceKey && guidanceKey !== this.lastGuidanceKey && this.running) {
        this.cue();
        this.announce(this.config.labels.decant + '. ' + this.getFrenchPressInstruction(stage));
      }
      this.lastGuidanceKey = guidanceKey;
    }
  };

  BrewTimer.prototype.tick = function() {
    if (!this.running) return;
    this.elapsed = Math.min(this.duration, (Date.now() - this.startedAt) / 1000);
    if (this.method === 'espresso' && this.elapsed >= this.duration) {
      this.stopEspresso(true);
      return;
    }
    if (this.method !== 'espresso' && this.elapsed >= this.duration) {
      this.running = false;
      this.complete = true;
      this.cue(true);
      this.announce((this.method === 'french_press' ? this.config.labels.frenchPressComplete : this.config.labels.complete) + '. ' + this.resolveInstruction('complete', this.method === 'french_press' ? this.config.labels.frenchPressReady : this.config.labels.ready));
      this.render();
      return;
    }
    this.render();
    this.frame = window.requestAnimationFrame(this.tick.bind(this));
  };

  BrewTimer.prototype.toggle = function() {
    if (this.complete) {
      this.reset();
      this.start();
    } else if (this.method === 'espresso' && this.running) {
      this.stopEspresso(false);
    } else if (this.running) {
      this.pause();
      this.render();
      this.announce(this.config.labels.pause);
    } else {
      this.start();
    }
  };

  BrewTimer.prototype.start = function() {
    this.setMethodPickerExpanded(false, false);
    var initialStart = this.elapsed === 0;
    this.startedAt = Date.now() - (this.elapsed * 1000);
    this.running = true;
    this.complete = false;
    this.render();
    if (initialStart && this.method === 'french_press') this.cue();
    this.announce(this.getStageAnnouncement(this.stages[this.getStageIndex()]));
    this.frame = window.requestAnimationFrame(this.tick.bind(this));
  };

  BrewTimer.prototype.stopEspresso = function(autoStopped) {
    if (!autoStopped) this.elapsed = Math.min(this.duration, (Date.now() - this.startedAt) / 1000);
    if (autoStopped) {
      this.elapsed = this.duration;
      this.targetCueFired = true;
      this.cue(true);
    }
    this.pause();
    this.stopElapsed = this.elapsed;
    this.complete = true;
    this.render();
    this.announce(this.getEspressoSummary() + '. ' + this.resolveInstruction('complete', this.config.labels.espressoReady));
  };

  BrewTimer.prototype.pause = function() {
    this.running = false;
    if (this.frame) window.cancelAnimationFrame(this.frame);
    this.frame = null;
  };

  BrewTimer.prototype.reset = function() {
    this.pause();
    this.elapsed = 0;
    this.complete = false;
    this.stopElapsed = null;
    this.lastStageIndex = -1;
    this.lastGuidanceKey = null;
    this.targetCueFired = false;
    this.render();
    this.announce(this.config.labels.start);
  };

  BrewTimer.prototype.moveStage = function(direction) {
    if (this.method === 'espresso') return;
    var index = this.getStageIndex();
    var target = Math.min(this.stages.length - 1, Math.max(0, index + direction));
    if (target === index) return;
    this.elapsed = this.stages[target].start;
    this.complete = false;
    if (this.running) this.startedAt = Date.now() - (this.elapsed * 1000);
    this.render();
    if (!this.running) this.announce(this.getStageAnnouncement(this.stages[target]));
  };

  BrewTimer.prototype.toggleCues = function() {
    this.cuesEnabled = !this.cuesEnabled;
    this.cuesButton.setAttribute('aria-pressed', String(this.cuesEnabled));
    this.cueLabel.textContent = this.cuesEnabled ? this.config.labels.cuesOn : this.config.labels.cuesOff;
    if (this.cuesEnabled) {
      var AudioContext = window.AudioContext || window.webkitAudioContext;
      if (AudioContext && !this.audioContext) this.audioContext = new AudioContext();
      if (this.audioContext && this.audioContext.state === 'suspended') this.audioContext.resume();
      this.cue();
    }
  };

  BrewTimer.prototype.cue = function(completion) {
    if (!this.cuesEnabled) return;
    if ('vibrate' in navigator) navigator.vibrate(completion ? [60, 40, 60] : 50);
    if (!this.audioContext) return;
    var oscillator = this.audioContext.createOscillator();
    var gain = this.audioContext.createGain();
    oscillator.frequency.value = completion ? 880 : 660;
    gain.gain.setValueAtTime(0.0001, this.audioContext.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.08, this.audioContext.currentTime + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, this.audioContext.currentTime + 0.18);
    oscillator.connect(gain).connect(this.audioContext.destination);
    oscillator.start();
    oscillator.stop(this.audioContext.currentTime + 0.2);
  };

  BrewTimer.prototype.announce = function(message) {
    if (this.announcementTimeout) window.clearTimeout(this.announcementTimeout);
    this.status.textContent = '';
    this.announcementTimeout = window.setTimeout(function() {
      this.status.textContent = message;
      this.announcementTimeout = null;
    }.bind(this), 20);
  };

  BrewTimer.prototype.destroy = function() {
    this.closeHelp(false);
    this.pause();
    if (this.announcementTimeout) window.clearTimeout(this.announcementTimeout);
    this.announcementTimeout = null;
    this.abortController.abort();
    if (this.audioContext) this.audioContext.close();
    this.root.removeAttribute('data-brew-timer-ready');
  };

  function init(scope) {
    var roots = [];
    if (scope.matches && scope.matches(SELECTOR)) roots.push(scope);
    roots = roots.concat(Array.from(scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : []));
    roots.forEach(function(root) {
      if (instances.has(root) || !root.querySelector('[data-brew-timer-config]')) return;
      root.setAttribute('data-brew-timer-ready', 'true');
      instances.set(root, new BrewTimer(root));
    });
  }

  function unload(scope) {
    instances.forEach(function(instance, root) {
      if (root === scope || scope.contains(root)) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  function handlePageChange() {
    instances.forEach(function(instance, root) {
      if (!document.documentElement.contains(root)) {
        instance.destroy();
        instances.delete(root);
      }
    });
    init(document);
  }

  window.LoomCoffeeBrewTimer = { init: init, unload: unload };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function(event) { unload(event.target); });
  if (typeof InstantClick !== 'undefined') InstantClick.on('change', handlePageChange);
})();
